import SendSingleEmail from './SendSingleEmail';

export default SendSingleEmail;
